// Build - A/B Test - Limited Quantity Messaging on PDP - 86b17zyx6
/**
 * Used: sections\main-product.liquid
 * -----------------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', () => {
  // Check if the specific class exists in the DOM
  const targetElement = document.querySelector('.limited-qty-message'); 

  if (targetElement) {
    const productOptionWrapper = document.querySelector('.product__info-container');

    const observer = new MutationObserver((mutations) => {
      const inventoryInputs = document.querySelectorAll('input[type="radio"][data-inventory]');
      if (inventoryInputs.length > 0) {
        observer.disconnect(); // Stop observing once inputs are available
        initializeInventoryLogic(inventoryInputs);
      }
    });

    if (productOptionWrapper) {
      observer.observe(productOptionWrapper, { childList: true, subtree: true });
    }

    function initializeInventoryLogic(inventoryInputs) {
      const associatedMessage = document.querySelector('.limited-qty-message');

      function updateInventoryMessage(selectedInput) {
        const allMessages = document.querySelectorAll('.limited-qty-message');
        const inventoryLeft = parseInt(selectedInput.getAttribute('data-inventory'), 10);

        allMessages.forEach((message) => {
          message.classList.add('!hidden'); // Hide all messages
        });

        if (inventoryLeft > 0 && inventoryLeft <= 10) {
          const inventorySpan = associatedMessage.querySelector('.inventory-left');
          inventorySpan.textContent = inventoryLeft;
          associatedMessage.classList.remove('!hidden');
        }
      }

      // Add event listener for multi-variant products
      inventoryInputs.forEach((input) => {
        input.addEventListener('change', () => updateInventoryMessage(input));
      });

      // Handle single-variant or pre-selected multi-variant products on load
      if (inventoryInputs.length === 1) {
        updateInventoryMessage(inventoryInputs[0]);
      } else {
        const defaultSelectedInput = Array.from(inventoryInputs).find((input) => input.checked);
        if (defaultSelectedInput) updateInventoryMessage(defaultSelectedInput);
      }
    }
  }
});
